import { Modal as Bs5Modal } from 'react-bootstrap5';

export default Bs5Modal;
